import {
  Component,
  OnInit,
  OnDestroy,
  ViewChild,
  ElementRef,
  HostListener,
} from '@angular/core';
import { trigger, style, animate, transition } from '@angular/animations';
import { Subscription } from 'rxjs';

import { StateService } from '@services/Logic/state.service';

@Component({
  selector: 'app-info',
  animations: [
    trigger('infoAnimation', [
      transition(':enter', [
        style({ opacity: '0' }),
        animate('500ms', style({ opacity: '1' })),
      ]),
      transition(':leave', [
        style({ opacity: '1' }),
        animate('200ms', style({ opacity: '0' })),
      ]),
    ]),
  ],
  templateUrl: './info.component.html',
  styleUrls: ['./info.component.scss'],
})
export class InfoComponent implements OnInit, OnDestroy {
  @ViewChild('info') info: ElementRef;

  showInfoComponentRef: Subscription;
  data: any;
  isVisible: boolean;
  posTop: number;
  posLeft: number;

  constructor(private stateService: StateService) {}

  ngOnInit() {
    this.data = null;
    this.isVisible = false;

    this.showInfoComponentRef =
      this.stateService.showInfoComponentSource.subscribe((res) => {
        this.isVisible = true;
        this.data = res;
        setTimeout(() => {
          this.initContentPosition();
        });
      });
  }

  ngOnDestroy() {
    this.showInfoComponentRef.unsubscribe();
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    if (this.isVisible) {
      this.initContentPosition();
    }
  }

  initContentPosition() {
    if (!this.data.elementId) {
      return this.close();
    }
    const el = document.getElementById(this.data.elementId);
    if (!el) {
      return this.close();
    }

    const bound = el.getBoundingClientRect();
    if (this.data.direction === 'down') {
      this.posTop = bound.top - 60 - 16;
      this.posLeft = bound.left;
    } else {
      this.posTop = bound.top + bound.height;
      this.posLeft =
        bound.left + bound.width / 2 - this.info.nativeElement.clientWidth + 16;
    }
  }

  getDirection() {
    return !this.data || this.data.direction === 'up' ? 'up' : 'down';
  }

  close() {
    this.isVisible = false;
    this.data = null;
  }
}
